import { useMutation } from '@apollo/client';
import { graphql } from '@client/graphql/types';

const UPDATE_HUBPAGE_QUERY = graphql(`
  mutation updateHubPage($companyID: ID!, $input: HubPageUpdateInput!, $companyInput: UpdateCompanyInput!) {
    updateHubPage(companyID: $companyID, input: $input) {
      companyId
    }

    updateCompany(companyID: $companyID, input: $companyInput) {
      id
      logo
      name
    }
  }
`);

export function useUpdateHubpageAndCompany() {
  return useMutation(UPDATE_HUBPAGE_QUERY, {
    refetchQueries: ['Company'],
  });
}
